module.exports = __webpack_public_path__ + "img/landing-social-screen-1.a5f23767.png";